export const Types = {
  //Get - List
  GET_GROUPS_LIST_REQUEST: 'GET_GROUPS_LIST_REQUEST',
  GET_GROUPS_LIST_SUCCESS: 'GET_GROUPS_LIST_SUCCESS',
  GET_GROUPS_LIST_FAIL: 'GET_GROUPS_LIST_FAIL',

  //Set for Update list
  SET_UPDATE_GROUPS_LIST: 'SET_UPDATE_GROUPS_LIST',

  //Store - Add
  POST_GROUPS_ADD_REQUEST: 'POST_GROUPS_ADD_REQUEST',
  POST_GROUPS_ADD_SUCCESS: 'POST_GROUPS_ADD_SUCCESS',
  POST_GROUPS_ADD_FAIL: 'POST_GROUPS_ADD_FAIL',

  //Update - Edit
  PUT_GROUPS_EDIT_REQUEST: 'PUT_GROUPS_EDIT_REQUEST',
  PUT_GROUPS_EDIT_SUCCESS: 'PUT_GROUPS_EDIT_SUCCESS',
  PUT_GROUPS_EDIT_FAIL: 'PUT_GROUPS_EDIT_FAIL',

  //Delete
  DELETE_GROUPS_DEL_REQUEST: 'DELETE_GROUPS_DEL_REQUEST',
  DELETE_GROUPS_DEL_SUCCESS: 'DELETE_GROUPS_DEL_SUCCESS',
  DELETE_GROUPS_DEL_FAIL: 'DELETE_GROUPS_DEL_FAIL',

  //CLear 
  CLEAR_ALL_REQUEST: 'CLEAR_ALL_REQUEST',
};

const INITIAL_STATE = {
  dataList: [],
  loadingList: false,
  errorList: false,
  errorDataList: false,
  dataListUpdate: false,

  loadingAdd: false,
  errorAdd: false,
  errorDataAdd: false,

  loadingEdit: false,
  errorEdit: false,
  errorDataEdit: false,

  loadingDelete: false,
  errorDelete: false,
  errorDataDelete: false,

};

export default function groups(state = INITIAL_STATE, action) {
  switch (action.type) {
    //Get - List
    case Types.GET_GROUPS_LIST_REQUEST:
      return {
        ...state,
        loadingList: true,
        errorList: false,
      };
    case Types.GET_GROUPS_LIST_SUCCESS:
      return {
        ...state,
        dataList: action.payload,
        loadingList: false,
        errorList: false,
        errorDataList: false
      };
    case Types.GET_GROUPS_LIST_FAIL:
      return {
        ...state,
        dataList: false,
        loadingList: false,
        errorList: true,
        errorDataList: action.payload,
      };

    case Types.SET_UPDATE_GROUPS_LIST:
      return {
        ...state,
        dataListUpdate: action.payload,
      };

    //Store - Add
    case Types.POST_GROUPS_ADD_REQUEST:
      return {
        ...state,
        loadingAdd: true,
        errorAdd: false,
      };
    case Types.POST_GROUPS_ADD_SUCCESS:
      return {
        ...state,
        loadingAdd: false,
        errorAdd: false,
        errorDataAdd: false,
      };
    case Types.POST_GROUPS_ADD_FAIL:
      return {
        ...state,
        loadingAdd: false,
        errorAdd: true,
        errorDataAdd: action.payload,
      };

    //Update - Edit
    case Types.PUT_GROUPS_EDIT_REQUEST:
      return {
        ...state,
        loadingEdit: true,
        errorEdit: false,
      };
    case Types.PUT_GROUPS_EDIT_SUCCESS:
      return {
        ...state,
        loadingEdit: false,
        errorEdit: false,
        errorDataEdit: false,
      };
    case Types.PUT_GROUPS_EDIT_FAIL:
      return {
        ...state,
        loadingEdit: false,
        errorEdit: true,
        errorDataEdit: action.payload,
      };

    //Delete 
    case Types.DELETE_GROUPS_DEL_REQUEST:
      return {
        ...state,
        loadingDelete: true,
        errorDelete: false,
      };
    case Types.DELETE_GROUPS_DEL_SUCCESS:
      return {
        ...state,
        loadingDelete: false,
        errorDelete: false,
        errorDataDelete: false,
      };
    case Types.DELETE_GROUPS_DEL_FAIL:
      return {
        ...state,
        loadingDelete: false,
        errorDelete: true,
        errorDataDelete: action.payload,
      };

    //Clear
    case Types.CLEAR_ALL_REQUEST:
      return {
        ...state,

        dataList: false,
        loadingList: false,
        errorList: false,
        errorDataList: false,
        dataListUpdate: false,

        loadingAdd: false,
        errorAdd: false,
        errorDataAdd: false,

        loadingEdit: false,
        errorEdit: false,
        errorDataEdit: false,

        loadingDelete: false,
        errorDelete: false,
        errorDataDelete: false,

      };

    default:
      return state;
  }
}

export const Creators = {

  //Get - List
  getGroupsListRequest: (payload) => ({
    type: Types.GET_GROUPS_LIST_REQUEST,
    payload,
  }),
  getGroupsListRequestSuccess: (payload) => ({
    type: Types.GET_GROUPS_LIST_SUCCESS,
    payload,
  }),
  getGroupsListRequestFail: (payload) => ({
    type: Types.GET_GROUPS_LIST_FAIL,
    payload,
  }),

  setUpdateGroups: (payload) => ({
    type: Types.SET_UPDATE_GROUPS_LIST,
    payload,
  }),

  //Store - Add 
  postGroupsAddRequest: (payload) => ({
    type: Types.POST_GROUPS_ADD_REQUEST,
    payload,
  }),
  postGroupsAddRequestSuccess: () => ({
    type: Types.POST_GROUPS_ADD_SUCCESS,
  }),
  postGroupsAddRequestFail: (payload) => ({
    type: Types.POST_GROUPS_ADD_FAIL,
    payload,
  }),

  //Update - Edit 
  putGroupsEditRequest: (payload) => ({
    type: Types.PUT_GROUPS_EDIT_REQUEST,
    payload,
  }),
  putGroupsEditRequestSuccess: () => ({
    type: Types.PUT_GROUPS_EDIT_SUCCESS,
  }),
  putGroupsEditRequestFail: (payload) => ({
    type: Types.PUT_GROUPS_EDIT_FAIL,
    payload,
  }),

  //Delete 
  deleteGroupsDelRequest: (payload) => ({
    type: Types.DELETE_GROUPS_DEL_REQUEST,
    payload,
  }),
  deleteGroupsDelRequestSuccess: () => ({
    type: Types.DELETE_GROUPS_DEL_SUCCESS,
  }),
  deleteGroupsDelRequestFail: (payload) => ({
    type: Types.DELETE_GROUPS_DEL_FAIL,
    payload,
  }),

  //Clear
  clearAllRequest: () => ({
    type: Types.CLEAR_ALL_REQUEST
  }),
};
